export enum FieldType {
  Textbox = "Textbox",
  Textarea = "Textarea",
  Date = "Date",
  DateTime = "DateTime",
  Checkbox = "Checkbox",
  ListboxGroup = "ListboxGroup",
  // CheckboxGroup = "CheckboxGroup",
  // RadioButtonGroup = "RadioButtonGroup",
  GeocodedAddress = "GeocodedAddress",
  PhotoIdentificationUpload = "PhotoIdentificationUpload",
  Number = "Number",
  Time = "Time",
  MemberPhotoUpload = "MemberPhotoUpload",
}

export const FieldTypeList = () =>
  Object.entries(FieldType).map(([label, value]) => {
    return { label, value };
  });
